import i18n from 'i18next'
import LngDetector from 'i18next-browser-languagedetector'
import pdfjsLib from 'pdfjs-dist/webpack'
import * as React from 'react'
import { initReactI18next } from 'react-i18next'
// @mui
import makeStyles from '@mui/styles/makeStyles'
import LinearProgress from '@mui/material/LinearProgress'
//
import Viewer from './components/Viewer'
//

i18n.use(initReactI18next).use(LngDetector).init({
  resources: {
    ja: {
      translation: {
        "MissingPDFException": "PDFファイルの取得に失敗しました。画面を更新してみてください。",

        "nowloading": "ファイルを読込中 ...",

        "page_scale_actual": "実際のサイズで表示",
        "page_scale_width": "画面幅に合わせる",
        "page_scale_fit": "画面サイズに合わせる",

        "page_mode_one_by_one": "1ページ毎",
        "page_mode_two_in_one": "2ページ毎",
        "page_mode_sequential": "連続表示",

        "toggle_fullscreen": "フルスクリーン切り替え",
      },
    },
    en: {
      translation: {
        "MissingPDFException": "An error occurred while loading the PDF. Try refreshing the screen.",

        "nowloading": "Now Loading ...",

        "page_scale_actual": "Actual Size",
        "page_scale_width": "Page Width",
        "page_scale_fit": "Page Fit",

        "page_mode_one_by_one": "One by One",
        "page_mode_two_in_one": "Two in One",
        "page_mode_sequential": "Sequential",

        "toggle_fullscreen": "Toggle fullscreen",
      },
    },
    'zh-CN': {
      translation: {
        "MissingPDFException": "载入 PDF 时发生错误。尝试刷新屏幕。",

        "nowloading": "正在载入档案 ...",

        "page_scale_actual": "实际大小",
        "page_scale_width": "适合页宽",
        "page_scale_fit": "适合页面",

        "page_mode_one_by_one": "逐页",
        "page_mode_two_in_one": "各2页",
        "page_mode_sequential": "连续显示",

        "toggle_fullscreen": "切换全屏",
      },
    },
    'zh-TW': {
      translation: {
        "MissingPDFException": "載入 PDF 時發生錯誤。嘗試刷新屏幕。",

        "nowloading": "正在載入檔案 ...",

        "page_scale_actual": "實際大小",
        "page_scale_width": "頁面寬度",
        "page_scale_fit": "縮放至頁面大小",

        "page_mode_one_by_one": "逐頁",
        "page_mode_two_in_one": "各2頁",
        "page_mode_sequential": "連續顯示",

        "toggle_fullscreen": "切換全屏",
      },
    },
  },
  // lng: 'ja',
  fallbackLng: 'ja',
  interpolation: { escapeValue: false },
})

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
  },
  error: {
    margin: theme.spacing(2),
    color: theme.palette.error.main,
  },
  nowLoading: {
    margin: theme.spacing(2),
  },
}))

const App = (props) => {
  const classes = useStyles()
  // states
  const [pdf, setPDF] = React.useState(null)
  const [loadingProgress, setLoadingProgress] = React.useState(null)
  // const [loaded, setLoaded] = React.useState(null)
  const [error, setError] = React.useState(null)

  const { src, token } = props

  // !!! Right click menu disabled !!!
  document.oncontextmenu = () => { return false }

  // functions
  const renderViewer = () => {
    return <Viewer pdf={pdf} {...props} />
  }

  function renderError() {
    let message = 'Error'
    switch (error.name) {
      case 'MissingPDFException':
        message = i18n.t('MissingPDFException')
        break
      default:
    }
    return <p className={classes.error}>{message}</p>
  }

  function renderLoading() {
    var loaded = undefined
    if (loadingProgress == null) {
      setTimeout(() => {
        const loadingTask = pdfjsLib.getDocument({
          url: src,
          httpHeaders: { 'X-PDF-TOKEN': token },
          // フォント表示のための設定
          cMapUrl: '/packs/cmaps/',
          cMapPacked: true,
        })

        loadingTask.onProgress = (progress) => {
          //console.debug('progress:', progress)
          setLoadingProgress(progress)
        }
        loadingTask.promise.then(_pdf => {
          setPDF(_pdf)
        }, error => {
          console.error(error)
          setError(error)
        })
      }, 1)
    } else {
      loaded = loadingProgress.loaded / loadingProgress.total * 100
    }

    return (
      <React.Fragment>
        {loaded === undefined ?
          <LinearProgress variant="indeterminate" /> :
          <LinearProgress variant="determinate" value={loaded} />
        }
        <p className={classes.nowLoading}>{i18n.t('nowloading')} {loaded === undefined ? null : `${Math.floor(loaded)} %`}</p>
      </React.Fragment>
    )
  }

  // main

  if (error) {
    return renderError()
  } else if (null == pdf) {
    return renderLoading()
  } else {
    return renderViewer()
  }
}

export default App
